import React from 'react'
import { Label } from 'semantic-ui-react'
import useAxios from 'hooks/useAxios'
import * as R from 'ramda'
import ClosedSurveyLabel from 'components/ClosedSurveyLabel'

/**
 *
 * @typedef Survey
 * @property {string} status
 * @property {string} type
 * @property {string} token
 * @property {boolean} is_closed
 * @property {string} closed_at
 */
const defaultSurvey = {
  status: '',
  type: '',
  token: '',
  is_closed: false,
  closed_at: '',
}

/**
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {Survey} props.survey
 * @param {boolean} props.isOngoingEmailLive
 */
export default function SurveyStatusLabel({
  survey = defaultSurvey,
  className,
  isOngoingEmailLive,
}) {
  const isOngoingEmailSurvey = ['NPS', 'ongoing_email'].includes(survey.type)
  const isSurveyClosed = survey.is_closed

  if (isOngoingEmailSurvey) {
    return (
      <OngoingEmailStatusLabel
        className={className}
        isOngoingEmailLive={isOngoingEmailLive}
        isSurveyClosed={isSurveyClosed}
        closed_at={survey.closed_at}
      />
    )
  }

  if (survey.type === 'oneoff_email') {
    return (
      <OneOffEmailStatusLabel
        className={className}
        surveyToken={survey.token}
        isSurveyClosed={isSurveyClosed}
        closed_at={survey.closed_at}
      />
    )
  }

  return isSurveyClosed ? (
    <ClosedSurveyLabel className={className} closed_at={survey.closed_at} />
  ) : null
}

function OneOffEmailStatusLabel({ className, surveyToken, isSurveyClosed, closed_at }) {
  const { data: emailSurveySetting } = useAxios({
    url: `survey/survey/${surveyToken}/email-survey-setting/`,
    skip: surveyToken === undefined,
  })
  const oneOffSurveyState = R.prop('delivery_status', emailSurveySetting)

  if (isSurveyClosed) {
    if (oneOffSurveyState === 'sent') {
      return (
        <React.Fragment>
          <Label className={className} color="green">
            Sent
          </Label>
          <ClosedSurveyLabel className={className} closed_at={closed_at} />
        </React.Fragment>
      )
    } else {
      return <ClosedSurveyLabel className={className} closed_at={closed_at} />
    }
  }

  if (oneOffSurveyState) {
    const mapSurveyState = {
      draft: { text: 'Draft', color: '' },
      sent: { text: 'Sent', color: 'green' },
      scheduled: { text: 'Scheduled', color: 'orange' },
    }
    const surveyState = mapSurveyState[oneOffSurveyState]

    return (
      <Label className={className} color={surveyState.color}>
        {surveyState['text']}
      </Label>
    )
  }

  return null
}
/**
 *
 * @param {object} props
 * @param {string} [props.className]
 * @param {boolean} props.isOngoingEmailLive
 * @param {boolean} props.isSurveyClosed
 * @param {string} props.closed_at
 */
function OngoingEmailStatusLabel({ className, isOngoingEmailLive, isSurveyClosed, closed_at }) {
  if (isSurveyClosed) {
    const paused = !isOngoingEmailLive
    if (paused) {
      return (
        <React.Fragment>
          <Label className={className}>Paused</Label>
          <ClosedSurveyLabel className={className} closed_at={closed_at} />
        </React.Fragment>
      )
    } else {
      return <ClosedSurveyLabel className={className} closed_at={closed_at} />
    }
  }

  if (isOngoingEmailLive) {
    return (
      <Label color="green" className={className}>
        Live
      </Label>
    )
  }

  return <Label className={className}>Paused</Label>
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/SurveyStatusLabel/index.js